export default "__VITE_ASSET__9e0514c5__"